import React from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { Box } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { DataBlockLayout } from "@components";
import { DividendsKpiStrip } from "./DividendsKpiStrip";
import { useChartOptions } from "./useChartOptions";
import type { DividendPerYear } from "@bn/api/apiv1";

const StyledContentBlock = styled(DataBlockLayout)({
  width: "100%",
});

interface Props {
  dividends?: DividendPerYear[];
  currency?: string;
  isFetching?: boolean;
}

export const DividendsBaseChart = ({
  dividends,
  currency,
  isFetching,
}: Props) => {
  const { t } = useTranslation();

  const title = t("fundamentals.metrics.dividendsPerYear.normal");
  const desc = t("fundamentals.metrics.dividendsPerYear.desc");

  const options = useChartOptions({ dividends, currency });

  return (
    <StyledContentBlock
      title={title}
      isFetching={isFetching}
      toolTipData={{ desc1: desc }}
    >
      <DividendsKpiStrip dividends={dividends} currency={currency} />
      <Box pt={3} px={4} pb={2} width="100%">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </Box>
    </StyledContentBlock>
  );
};
